export class DealState {
    public dealStateId: number = 0;
    public name: string = 'Unknown';
    public order: number = 0;
}
